import React from 'react'
import Footer from '../footer/footer'
import StudyGer from './StudyGer'

function StudyAtR() {
  return (
    <div>
    <StudyGer
    title="Rusia"/>
    <Footer/>
    </div>
  )
}

export default StudyAtR